import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    findInStoreForm: 'f-col gap-4 lg:(flex-row items-center between)'
  }
} satisfies RecursivePartial<DialogConfig['pickupInStore']>
